<template>
 <div class="collection-consultations">
   <a v-if="linkWhatsApp" :href="linkWhatsApp" rel="nofollow noopener noreferrer" target="_blank" class="btn btn-primary">
     <img src="~/assets/img/svg/social-media/whatsapp.svg" alt=""/>
     <span class="--pc">Консультация в WhatsApp</span>
     <span class="--mobile">Консультация</span>
   </a>
   <a v-if="linkMax" :href="linkMax" rel="nofollow noopener noreferrer" target="_blank" class="btn btn-primary">
     <img src="~/assets/img/svg/social-media/max.svg" alt="" />
     <span class="--pc">Консультация в МАКС</span>
     <span class="--mobile">Консультация</span>
   </a>
   <a v-if="linkTelegram" :href="linkTelegram" rel="nofollow noopener noreferrer" target="_blank" class="btn btn-primary">
     <img src="~/assets/img/svg/social-media/telegram.svg" width="28px" height="28px" alt=""/>
     <span class="--pc">Консультация в Telegram</span>
     <span class="--mobile">Консультация</span>
   </a>
 </div>
</template>

<script lang="ts" setup>
import { appConfigStore as useAppConfigStore } from '#sitis/stores/modules/app-store';

const appConfigStore = useAppConfigStore();

const props = defineProps({
  productName: {
    type: String,
    default: ''
  }
});

const sendMessage = computed(() => {
  return `Доброго времени суток, нужно консультация по товару "${ props.productName }"`
})
const linkWhatsApp = computed(() => {
  const link = appConfigStore.vars.Whatsapp || appConfigStore.config?.whatsapp || "";
  if (!link) {
    return null
  }
  return `https://api.whatsapp.com/send?phone=${ link }&text=${encodeURIComponent(sendMessage.value)}`
});
const linkTelegram = computed(() => {
  const link = appConfigStore.vars.Telegram || appConfigStore?.config?.telegram || '';
  if (!link) {
    return null
  }
  return link
});
const linkMax = computed(() => {
  const link = appConfigStore.vars.MAX || appConfigStore.vars.max || '';
  if (!link) {
    return null
  }
  return link
})
</script>

<style lang="scss" scoped>
.collection-consultations {
  display: flex;
  flex-direction: column;

  & > * {
    margin-top: 16px;

    &:first-child {
      margin-top: 0;
    }
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: rgb(244 243 241 / 100%);
    border-radius: 16px;
    font-weight: 600;
    color: rgb(0 0 0 / 100%);
    gap: 10px;

    & > span {
      margin-top: 2px;
    }

    img {
      width: 28px; height: 28px;
      //display: none;
    }
    .--mobile {
      display: none;
    }
    &:hover {
      color: white;
      background-color: #2F2E2E;
      & > img {
        filter: invert(100%) sepia(0%) saturate(5026%) hue-rotate(201deg) brightness(111%) contrast(98%);
      }
    }
  }
}

@media (max-width: 1023px) {
  .collection-consultations {
    flex-direction: row;
    margin-top: 28px;

    & > * {
      flex: 1;
      margin-top: 0;
      margin-left: 16px;
      &:first-child {
        margin-left: 0;
      }
    }

    .btn {
      padding: 10px 16px;
      height: 48px;
      border-radius: 12px;


      img {
        display: block;
        width: 28px; height: 28px;
        object-fit: contain;
        margin-right: 6px;
      }
      .--pc {
        display: none;
      }
      .--mobile {
        display: block;
      }
    }
  }
}
</style>
